<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 19V5M12 5L7 10M12 5L17 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
